import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './components/pages/login/LoginPage';

import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the Data Grid
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Optional Theme applied to the Data Grid
import { useLoginStore } from './store/useLogin';
import { useEffect } from 'react';

function App() {
  const { autoLogin } = useLoginStore();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      autoLogin();
    }
  }, [autoLogin]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Layout />} />

        {/* 로그인 페이지 */}
        <Route path="/login" element={<Login />} />
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="light"
        transition={Slide}
        toastClassName={(context: any) => {
          const baseClasses =
            'relative flex flex-row items-center gap-3 py-4 px-5 h-auto min-h-[60px] rounded-lg cursor-pointer shadow-lg mb-2 mx-auto max-w-lg';

          switch (context?.type) {
            case 'success':
              return `${baseClasses} bg-green-50 border border-green-200`;
            case 'error':
              return `${baseClasses} bg-red-50 border border-red-200`;
            case 'warning':
              return `${baseClasses} bg-amber-50 border border-amber-200`;
            case 'info':
              return `${baseClasses} bg-blue-50 border border-blue-200`;
            default:
              return `${baseClasses} bg-white border border-gray-200`;
          }
        }}
        bodyClassName={(context: any) => {
          const baseTextClasses = 'text-base font-medium p-0 m-0 flex';

          switch (context?.type) {
            case 'success':
              return `${baseTextClasses} text-green-800`;
            case 'error':
              return `${baseTextClasses} text-red-800`;
            case 'warning':
              return `${baseTextClasses} text-amber-800`;
            case 'info':
              return `${baseTextClasses} text-blue-800`;
            default:
              return `${baseTextClasses} text-gray-800`;
          }
        }}
        closeButton={false}
        limit={3}
        style={{
          width: 'auto',
          maxWidth: '500px',
          bottom: '0px !important',
          right: '4px !important',
        }}
      />
    </BrowserRouter>
  );
}

export default App;
